/* eslint-disable import/no-anonymous-default-export */
export default (adminIssuedCost = [], action) => {
  switch (action.type) {
    case "ADMIN_STOCK_ISSUED_MONTHLY":
      return action.payload;

    default:
      return adminIssuedCost;
  }
};
